import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import EnrichSalon from './components/salon';
import EnrichTnC from './components/tandc';
import EnrichPrivacyPolicy from './components/privacy';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<EnrichSalon />} />
        <Route path="/terms" element={<EnrichTnC />} />
        <Route path="/privacy" element={<EnrichPrivacyPolicy />} />
      </Routes>
    </Router>
  );
}

export default App;
